import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-362c0239"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "recorded" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://wasset.greedyai.com/sys/course/recorded.png",
  alt: "录播"
}, null, -1))
const _hoisted_4 = { class: "type" }
const _hoisted_5 = { class: "name" }
const _hoisted_6 = {
  key: 0,
  class: "finished"
}
const _hoisted_7 = {
  key: 1,
  class: "processing"
}
const _hoisted_8 = { class: "desc" }


import {CoursePlanPartVO} from "@/apis/course";
import {Check} from "@element-plus/icons";
import usePartConvert from "@/composables/usePartConvert";

// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default /*#__PURE__*/_defineComponent({
  __name: 'ScheduleRecorded',
  props: {
    part: {}
  },
  setup(__props: any) {

const props = __props

const {convertPartType} = usePartConvert()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(convertPartType)(_ctx.part)), 1),
      _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.part.partName), 1),
      (_ctx.part.userCoursePlanPart.rate===100)
        ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
            _createVNode(_unref(Check), { class: "icon" }),
            _createTextVNode("已完成")
          ]))
        : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString('已完成' + (_ctx.part.userCoursePlanPart.rate || 0) + '%'), 1))
    ]),
    _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.part.partDesc), 1)
  ]))
}
}

})